import Vue from 'vue'
import moment from 'moment'

export function formatDate(time) {
    return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ""
}

export function updateTimeByUtc(diff, time) {
    return time ? moment(time).add(+diff, 'hour').format('YYYY-MM-DD HH:mm:ss') : ""
}

function compareYear(birthday) {
    var moment = Vue.prototype.$moment
    var nowDate = moment()
    var year = nowDate.get('year')
    var month = nowDate.get('month') + 1
    var day = nowDate.get('date')

    var befYear = birthday.get('year')
    var befMonth = birthday.get('month') + 1
    var befday = birthday.get('date')

    var date = `${year}-${month}-${day+1}`
    var beforeDate = `${befYear+18}-${befMonth}-${befday}`

    return moment(date).isAfter(beforeDate, 'date')
}

export function getTimeDiff() {
    let timeDiff = sessionStorage.getItem('UTCDIFF')
    if (timeDiff) {
        return timeDiff
    } else {
        sessionStorage.setItem('UTCDIFF', new String(-new Date().getTimezoneOffset() / 60))
        return sessionStorage.getItem('UTCDIFF')
    }
}


// WEBPACK FOOTER //
// ./src/common/js/util.js